import type { PropsWithChildren } from 'react';
import * as React from 'react';

const defaultAudioDuration: number | null = null;

export interface WithAudioDuration {
  audioDuration?: number;
  setAudioDuration: (duration: number) => void;
}

export const AudioDurationContext = React.createContext<WithAudioDuration>({
  audioDuration: defaultAudioDuration,
  setAudioDuration: () => {},
});

const AudioDurationProvider: React.FC<PropsWithChildren> = ({ children }) => {
  const [audioDuration, setAudioDuration] = React.useState(null);

  const audioDurationValue = React.useMemo(
    () => ({ audioDuration, setAudioDuration }),
    [audioDuration],
  );

  console.log('AudioDurationProvider', audioDuration);
  return (
    <AudioDurationContext.Provider value={audioDurationValue}>
      {children}
    </AudioDurationContext.Provider>
  );
};

export default AudioDurationProvider;
